import { Locale } from '@enmon/commons';
import { DEFAULT_LOCALE } from './config';
import csTranslationMessages from './translations/cs.json';
import enTranslationMessages from './translations/en.json';
import plTranslationMessages from './translations/pl.json';
import skTranslationMessages from './translations/sk.json';

export type TranslationDictionary = Record<string, string>;

export const formatTranslationMessages = (
  locale: Locale,
  messages: TranslationDictionary,
  fallbackMessages: TranslationDictionary,
): TranslationDictionary => {
  if (locale === DEFAULT_LOCALE) {
    return { ...messages };
  }

  const result: TranslationDictionary = {};

  for (const key in fallbackMessages) {
    result[key] = messages[key] || fallbackMessages[key] || '';
  }

  return result;
};

export const SHARED_TRANSLATION_MESSAGES: Record<Locale, TranslationDictionary> = {
  [Locale.EN]: formatTranslationMessages(Locale.EN, enTranslationMessages, csTranslationMessages),
  [Locale.CS]: formatTranslationMessages(Locale.CS, csTranslationMessages, csTranslationMessages),
  [Locale.SK]: formatTranslationMessages(Locale.SK, skTranslationMessages, csTranslationMessages),
  [Locale.PL]: formatTranslationMessages(Locale.PL, plTranslationMessages, csTranslationMessages),
};
